import { IsString } from 'class-validator';

export class NomenclatureTypeCopyRequest {
    @IsString()
    public uuid: string;

    constructor(data?: Partial<NomenclatureTypeCopyRequest>) {
        this.uuid = data && data.uuid;
    }
}
